import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Subscription } from "rxjs";
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { IGaritaResponse } from '../../modelos/IMantGarita';
import { IMantBascula } from '../../modelos/IMantBascula';
import { IUsuarioAll } from '../../modelos/IUsuario.js';
import { KardexService } from '../../services/kardex.service';
import { ProveedorService } from '../../services/proveedor.service';
import {Row, Workbook as wb, Worksheet} from "exceljs";
import {saveAs} from 'file-saver';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-kardex',
  templateUrl: './kardex.component.html',
  styleUrls: ['./kardex.component.css']

})
export class KardexComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.kardex;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;

  public agregarForm = new FormGroup({
    proveedor: new FormControl(null, []),
    despro: new FormControl(null, []),
    estado: new FormControl(null, []),
  });

  public cmbUsuarios: IUsuarioAll[] = [];
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private kardexS: KardexService,
    private proveedorS: ProveedorService,
  ) {
  }

  proveedorInvalido = false;
  ngOnInit() {
    this.girdComponent();

    this.agregarForm.get('proveedor').valueChanges
      .subscribe((resp) => {
        if (resp) {
          console.log("proveedor change", resp);
          this._util.mensajeOKToast('Proveedor correcto.');
        
          // paso para proveedor 0
          if(this.agregarForm.get("proveedor").value == "0"){
            this.proveedorInvalido = true;
            this._util.mensajeOKToast('Proveedor TODOS.');
          }else{

            this.proveedorS.obtenerPorRuc(this.agregarForm.get("proveedor").value).subscribe(
              (resp) => {
                this.loading = false;
                if (resp) {
                  this.proveedorInvalido = false;
                  this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
                  this._util.mensajeOKToast('Proveedor correcto.');
                } else {
                  this.proveedorInvalido = true;
                  this._util.mensajeErroToast('Proveedor incorrecto.');
                  this.agregarForm.controls['despro'].setValue('');
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                this.proveedorInvalido = true;
                this.agregarForm.controls['despro'].setValue('');
                this._util.mensajeErroToast('Proveedor incorrecto.');
              }
            );
          }
        }
      },
        (error) => {
          this.loading = false;
          this._util.mensajeErroToast("Provedor Incorrecto");
        });

        this.obtenerTodo();
  }

  procesar() {
  
    if (this.proveedorInvalido) this._util.mensajeErroToast('Proveedor incorrecto.');

    if(this.agregarForm.get("proveedor").value == "0"){
      
      this._util.mensajeOKToast('Genera Tabla para Proveedor TODOS.');

      this.kardexS.obtenerPorProveedor("0").subscribe(
        (resp) => {
          this.obtenerTodo();
        }
      );
      
    }else{

      this.proveedorS.obtenerPorRuc(this.agregarForm.get("proveedor").value).subscribe(
        (resp) => {
          if (resp) {
            this.proveedorInvalido = false;
            this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
            this.kardexS.obtenerPorProveedor(resp.idProveedor).subscribe(
              (resp) => {

                this.obtenerTodo();

              }
            );
          } else {
            this.proveedorInvalido = true;
            this.agregarForm.controls['despro'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.proveedorInvalido = true;
          this.agregarForm.controls['despro'].setValue('');
          this._util.mensajeErroToast(error.respuesta);
        }
      );
    }
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Proveedor',
        field: 'codProveedor',
        sortable: true,
        filter: true,
        width: 1000,
      },
      {
        headerName: 'Descripción',
        field: 'desProveedor',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Tipo',
        field: 'tipoDesciption',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Fecha Inicial',
        field: 'fechaInicio',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Fecha Final',
        field: 'fechaFin',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Valor Inicial',
        field: 'valorInicial',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Valor Final',
        field: 'valorFinal',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Nivel',
        field: 'nivel',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Factor',
        field: 'factor',
        sortable: true,
        filter: true,
      },
    ];
  }

  obtenerTodo() {
    // localhost:8080/balanza-api/v1/api/service/permios-castigo?idProveedor=31197
    this.loading = true;
    this.subscription.add(
      this.kardexS.obtenerTodo().subscribe(
        (resp) => {
          console.log("TODO", resp);
          resp.map(e => {
            e['tipoDesciption'] = e.paramCalidad == 1 ? "Humedad + Impireza" : "Acidez";
            e['fechaInicio'] = e.fechaInicio ? e.fechaInicio.split('T')[0] : "";
            return e;
          })
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  onChageProveedor() {

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  descargarExcel() {
    this.generarEcxel();
  }

  workbook: wb;
  data: any = [];
  dataExcel: any = [];

  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      let payload = {
        codProveedor: x.codProveedor,
        idusuario: x.idusuario,
        fechaInicio: formatDate(new Date(x.fechaInicio), 'dd-MM-yyyy', 'en'),
        fechaFin: formatDate(new Date(x.fechaFin), 'dd-MM-yyyy', 'en'),
        valorInicial: x.valorInicial,
        valorFinal: x.valorFinal,
        nivel: x.nivel,
        factor: x.factor,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'kardex' + '.xlsx');
    });
  }

  fillExcelMarketplace() {
    const nameSheet = 'KARDEX';
    let header;

    header = [
      'Proveedor',
      'Descripción',
      'Fecha Inicial',
      'Fecha Final',
      'Acidez Inicial',
      'Acidez Final',
      'Nivel Acidez',
      'Factor Acidez',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 20;
    worksheet.columns[3].width = 20;
    worksheet.columns[4].width = 15;
    worksheet.columns[5].width = 15;
    worksheet.columns[6].width = 15;
    worksheet.columns[7].width = 15;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatDataExcel();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatDataExcel(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }

}
